module.exports = __webpack_public_path__ + "img/logoAmarf.5ddd6bb6.png";